import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { PropertyListItem } from "@tento-ui/components/input/property-list";
import { DomUtils } from "@tento-ui/dom";
import { Typography } from "@tento-ui/ui/typography";
import { NaiveDate } from "@tento-chrono";

@component({ name: "debug-metadata-panel" })
export class DebugMetadataPanel extends LonaWebComponent {
  private $info: HTMLElement = this.$("info");
  private $syncDurationText: Option<HTMLElement> = null;

  bind(props: DebugMetadataPanel.Props): this {
    DomUtils.clearChildren(this.$info);

    this.$info.appendChild(
      PropertyListItem.makeWith({
        label: "Date Range",
        value: `${props.dateRange.start.toString()} to ${props.dateRange.end.toString()}`,
      }),
    );

    if (props.showSyncDuration) {
      const $durationText = Typography.p("Syncing...");
      $durationText.style.color = "var(--orange)";
      this.$syncDurationText = $durationText;
      this.$info.appendChild(
        PropertyListItem.make().bind({
          label: "Sync Duration",
          value: $durationText,
        }),
      );
    } else {
      this.$syncDurationText = null;
    }

    return this;
  }

  updateSyncDuration(durationMs: number): void {
    if (!this.$syncDurationText) return;

    this.$syncDurationText.textContent = this.formatDuration(durationMs);
    this.$syncDurationText.style.color = "var(--green)";
  }

  private formatDuration(durationMs: number): string {
    if (durationMs < 1000) {
      return `${durationMs}ms`;
    }
    return `${(durationMs / 1000).toFixed(1)}s`;
  }

  static $styles = [
    Typography.$style,
    ...PropertyListItem.$styles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        max-width: 400px;
      }

      #info {
        --label-min-width: 80px;
        --plist-height: 24px;
      }
    `,
  ];

  static $html = html`
    <std-col id="info"></std-col>
  `;
}

export namespace DebugMetadataPanel {
  export type DateRange = { start: NaiveDate; end: NaiveDate };
  export type Props = {
    dateRange: DateRange;
    showSyncDuration: boolean;
  };
}
